module.exports = __webpack_public_path__ + "media/img/portal/banner-portal-img2-27b6a44c256c1f2ee4848121ac551575.svg";